import { TenantPhoneNumberItem } from '@components/OutboundCallerIdSelection/types';
import { FC, useCallback, useState } from 'react';
import { DIRECT_LINE } from 'src/constants/tenantSelection';
import { OutboundCallerIdModal } from '../OutboundCallerIdModal';
import { OutboundCallerIdTableProvider } from '../context';
import { DisplayAgentCallerId } from './DisplayAgentCallerId';
import { useAgentLine } from './useAgentLine';
import { AgentCallerIdDetails } from './types';

interface AgentCallerIdProps {
  className?: string;
  onChange: (data: AgentCallerIdDetails) => void;
  tenantName?: string;
  tenantId?: string;
  onLoadingChange?: (loading: boolean) => void;
  isDynamic?: boolean;
}

export const AgentCallerId: FC<AgentCallerIdProps> = ({
  className,
  tenantName,
  tenantId,
  onChange,
  onLoadingChange,
  isDynamic = true,
}) => {
  const {
    selectedLine,
    showChangeButton,
    enableCustomOutboundCallerId,
    loadingCallerId,
    outgoingCallerId,
    onLineChange,
  } = useAgentLine({
    tenantId,
    onLoadingChange,
    onChange,
    isDynamic,
  });
  const [changePhoneOpen, setChangePhoneOpen] = useState(false);

  const onEditModalOpen = useCallback(() => {
    setChangePhoneOpen(true);
  }, []);

  const onEditModalClose = useCallback(() => {
    setChangePhoneOpen(false);
  }, []);

  const onSelectPhoneNumber = useCallback(
    (selectedItem: TenantPhoneNumberItem) => {
      onLineChange({
        callerId: selectedItem?.number,
        callerName: selectedItem?.name ?? undefined,
      });
      setChangePhoneOpen(false);
    },
    [onLineChange],
  );

  return (
    <>
      <DisplayAgentCallerId
        callerId={selectedLine?.callerId}
        callerName={selectedLine?.callerName ?? undefined}
        loading={loadingCallerId}
        showChangeButton={!!showChangeButton}
        onEditClick={onEditModalOpen}
        className={className}
      />

      {changePhoneOpen && (
        <OutboundCallerIdTableProvider
          tenantName={tenantName}
          tenantId={tenantId !== DIRECT_LINE ? tenantId : undefined}
          selectedLine={selectedLine?.callerId ?? ''}
          enableCustomOutboundCallerId={enableCustomOutboundCallerId}
          outgoingCallerId={outgoingCallerId}
          isDynamic={isDynamic}
        >
          <OutboundCallerIdModal
            onClose={onEditModalClose}
            onDone={onSelectPhoneNumber}
          />
        </OutboundCallerIdTableProvider>
      )}
    </>
  );
};
